const initialState = {
  delivery: true,
  pay_method: 1,
  contact_phone: "",
  email: "",
  order_address: "",
  observations: "",
  items: [],
};

export const ADD_BURGER = "ADD_BURGER";
export const EDIT_BURGER = "EDIT_BURGER";
export const ADD_SIDE_ITEM = "ADD_SIDE_ITEM";
export const SET_CART_INFO = "SET_CART_INFO";
export const RESET_CART = "RESET_CART";

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BURGER:
      return {
        ...state,
        items: [
          ...state.items,
          {
            item_type: 1,
            quantity: action.payload.quantity,
            burger: action.payload.burger,
          },
        ],
      };
    case EDIT_BURGER:
      const updatedItems = [...state.items];
      updatedItems[action.payload.index] = {
        item_type: 1,
        quantity: action.payload.quantity,
        burger: action.payload.burger,
      };
      return {
        ...state,
        items: updatedItems,
      };
    case ADD_SIDE_ITEM:
      return {
        ...state,
        items: [
          ...state.items,
          {
            item_type: 2,
            quantity: 1,
            side_item: action.payload,
          },
        ],
      };
    case SET_CART_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CART:
      return initialState;
    default:
      return state;
    case "REMOVE_CART_ITEM":
      return {
        ...state,
        items: state.items.filter((_, idx) => idx !== action.payload),
      };
  }
};

export default cartReducer;
